import { format, parseISO } from "date-fns";
import { it } from 'date-fns/locale';

import { Paper, Table, TableBody, TableContainer, TableHead, TableRow } from "@mui/material";

import { TableCellBottomStyle, TableCellFirstStyle, TableCellFooterStyle, 
        TableCellImportantStyle, TableCellStyle, TableFooterStyle, TableRowCustom } from "../../../../Theme/TableStyle";

export default function RenderTable(props) {
  const {dateRange, datasets} = props

  const columnSums = new Array(dateRange.length).fill(0);
  const formatDate = (dateString) => {
    const date = parseISO(dateString);
    return format(date, 'dd/MM', { locale: it });
  };
  const year = dateRange.length > 0 ? "Anno: " + format(parseISO(dateRange[0]), "yyyy", { locale: it }) : '';
  return (
    <Paper style={{ width: "100%", overflow: "hidden" }}> 
    <TableContainer style={{ padding: 16, textAlign: 'center', fontWeight: 'bold' }}>
        {year}
    </TableContainer>
    <TableContainer style={{ maxHeight: "calc(85vh - 200px)", overflow: "auto" }}> 
      <Table stickyHeader>
        <TableHead>
          <TableRow>
            <TableCellImportantStyle>Nome</TableCellImportantStyle>
            {dateRange.map((period, index) => (
              <TableCellImportantStyle key={index}>{formatDate(period)}</TableCellImportantStyle>
            ))}
            <TableCellImportantStyle>Totale</TableCellImportantStyle>
          </TableRow>
        </TableHead>
        <TableBody>
          {datasets[0].dataset.map((dataset, index) => {
            const rowSum = dataset.data.reduce((sum, value, dataIndex) => {
              columnSums[dataIndex] += value;
              return sum + value;
            }, 0);

            return (
              <TableRowCustom key={index}>
                <TableCellFirstStyle component="th" scope="row">
                  {dataset.label.split('-')[0].trim()}
                </TableCellFirstStyle>
                {dataset.data.map((data, idx) => (
                  <TableCellStyle key={idx}>
                    {data}
                  </TableCellStyle>
                ))}
                <TableCellBottomStyle>
                  {rowSum.toFixed(1)}
                </TableCellBottomStyle>
              </TableRowCustom>
            );
          })}
        </TableBody>
        <TableFooterStyle>
          <TableRow>
            <TableCellFooterStyle component="th" scope="row">Totale</TableCellFooterStyle>
              {columnSums.map((sum, index) => (
                <TableCellFooterStyle key={index}>{sum.toFixed(1)}</TableCellFooterStyle>
              ))}
            <TableCellFooterStyle>{columnSums.reduce((a, b) => a + b, 0).toFixed(1)}</TableCellFooterStyle>
          </TableRow>
        </TableFooterStyle>
      </Table>
    </TableContainer>
  </Paper>
  )
}
